import { APIClient } from '../helpers/api_helper';
const AxiosClient = new APIClient()

const getAuthUrl = () => AxiosClient.get('/redirect-to-azure');
const getUserToken = payload => AxiosClient.post('/callback', payload);
const azureLogout = () => AxiosClient.get('/azure-logout');




export {
    getAuthUrl,
    getUserToken,
    azureLogout
  
  }